var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, Teleport as _Teleport, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
    key: 0,
    href: "/sets/constructor/",
    class: "btn-set-constructor"
};
var _hoisted_2 = { class: "prod-filter__label" };
var _hoisted_3 = { class: "prod-filter__marker" };
var _hoisted_4 = { class: "prod-filter__main" };
var _hoisted_5 = {
    key: 0,
    class: "prod-filter__reset-btn"
};
var _hoisted_6 = ["disabled"];
import { onBeforeMount, ref } from "vue";
import FiltersList from './components/FiltersList.vue';
import { useFilterStore } from "./store";
import useFilterAPI from "./api";
import Sprite from "../../components/Sprite.vue";
import TextPreloader from "../../components/TextPreloader.vue";
import Sorting from "./components/Sorting.vue";
import ViewModeSwitch from "./components/ViewModeSwitch.vue";
import { UserSetConstructorApp } from "../sets_constructor";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FilterApp',
    props: {
        currentSort: String,
        setDraftData: { type: Object, default: null },
        setEditMode: { type: Boolean, default: false },
    },
    setup: function (__props) {
        var store = useFilterStore();
        var api = useFilterAPI();
        var expanded = ref(false);
        var sortingEl = document.getElementById('sorting');
        var viewSwitchEl = document.getElementById('view-switch');
        onBeforeMount(function () {
            sortingEl.innerHTML = '';
            viewSwitchEl.innerHTML = '';
        });
        function update(delayed) {
            store.updateValues();
            if (delayed) {
                api.updateResultsDelayed(true)
                    .catch(function (reason) {
                    if (reason === 'cancelled') {
                        return;
                    }
                    throw reason;
                });
            }
            else {
                api.updateResults(true);
            }
        }
        function reset() {
            store.values = {};
            api.updateResults(true);
        }
        function sortChange(code) {
            store.setSortType(code);
            api.updateResults(false);
        }
        return function (_ctx, _cache) {
            var _a;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(store).config.mode === 'SET')
                    ? (_openBlock(), _createElementBlock("a", _hoisted_1, "Собрать свой сет"))
                    : _createCommentVNode("v-if", true),
                _cache[6] || (_cache[6] = _createTextVNode()),
                (__props.setDraftData)
                    ? (_openBlock(), _createBlock(_unref(UserSetConstructorApp), _mergeProps({ key: 1 }, __props.setDraftData, { openModal: __props.setEditMode }), null, 16 /* FULL_PROPS */, ["openModal"]))
                    : _createCommentVNode("v-if", true),
                _cache[7] || (_cache[7] = _createTextVNode()),
                (_unref(store).enabled)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["prod-filter dropdown", { 'prod-filter--loading': !_unref(store).loaded, 'is-open': expanded.value }])
                    }, [
                        _createElementVNode("div", {
                            class: "prod-filter__top dropdown-toggle",
                            onClick: _cache[0] || (_cache[0] = function ($event) { return (expanded.value = !expanded.value); })
                        }, [
                            _createElementVNode("div", _hoisted_2, [
                                _cache[1] || (_cache[1] = _createTextVNode("Фильтры\n        ", -1 /* CACHED */)),
                                _createVNode(TextPreloader, {
                                    active: !_unref(store).loaded
                                }, null, 8 /* PROPS */, ["active"])
                            ]),
                            _cache[2] || (_cache[2] = _createTextVNode()),
                            _createElementVNode("div", _hoisted_3, [
                                _createVNode(Sprite, { name: "arrow-down" })
                            ])
                        ]),
                        _cache[5] || (_cache[5] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, [
                            _createVNode(FiltersList, { onUpdate: update }),
                            _cache[4] || (_cache[4] = _createTextVNode()),
                            (_unref(store).active)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn btn--2 btn--m btn--black wide",
                                        onClick: reset,
                                        disabled: !_unref(store).active
                                    }, __spreadArray([], __read((_cache[3] || (_cache[3] = [
                                        _createElementVNode("span", { class: "btn__label" }, "Сбросить все фильтры", -1 /* CACHED */)
                                    ]))), false), 8 /* PROPS */, _hoisted_6)
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ], 2 /* CLASS */))
                    : _createCommentVNode("v-if", true),
                _cache[8] || (_cache[8] = _createTextVNode()),
                (_openBlock(), _createBlock(_Teleport, { to: _unref(sortingEl) }, [
                    _createVNode(Sorting, {
                        onChange: sortChange,
                        current: (_a = _unref(store).sort.types[_unref(store).sort.type]) !== null && _a !== void 0 ? _a : __props.currentSort,
                        type: _unref(store).sort.type,
                        types: _unref(store).sort.types,
                        enabled: _unref(store).enabled
                    }, null, 8 /* PROPS */, ["current", "type", "types", "enabled"])
                ], 8 /* PROPS */, ["to"])),
                _cache[9] || (_cache[9] = _createTextVNode()),
                (_openBlock(), _createBlock(_Teleport, { to: _unref(viewSwitchEl) }, [
                    _createVNode(ViewModeSwitch)
                ], 8 /* PROPS */, ["to"]))
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
